import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

function InputField({ fieldState, helperText, label, params, placeholder, scrollableTags }) {
  const { InputProps = {}, inputProps, ...restParams } = params;
  const { startAdornment, ...restInputProps } = InputProps;

  return (
    <TextField
      {...restParams}
      error={!!fieldState?.error}
      helperText={fieldState?.error?.message || helperText}
      label={label}
      placeholder={placeholder}
      slotProps={{
        htmlInput: {
          ...inputProps,
          autoComplete: 'off',
        },
        input: {
          ...restInputProps,
          startAdornment: scrollableTags
            ? startAdornment && (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    maxHeight: 116,
                    overflowY: 'auto',
                    width: '100%',
                  }}
                >
                  {startAdornment}
                </div>
              )
            : startAdornment,
        },
        inputLabel: { shrink: true },
      }}
    />
  );
}

InputField.propTypes = {
  fieldState: PropTypes.shape({
    error: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
  helperText: PropTypes.string.isRequired,
  label: PropTypes.string,
  params: PropTypes.shape({
    inputProps: PropTypes.object,
    InputProps: PropTypes.shape({
      startAdornment: PropTypes.node,
    }),
  }).isRequired,
  placeholder: PropTypes.string,
  scrollableTags: PropTypes.bool,
};

InputField.defaultProps = {
  label: '',
  placeholder: '',
};

export default InputField;
